import React from 'react';
import {Form,Col} from "react-bootstrap";

class Clinical_data extends React.Component{
    render() {

        if (this.props.action == 'new') {
            return (

                <div>
                    <h4>Clinical Data</h4><br/>
                    <Form>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <Form.Label>PSP scale</Form.Label>
                                <Form.Control name="psp" type='text' onChange={this.props.handler}/>
                            </Form.Group>
                            <Form.Group as={Col}>
                                <Form.Label>MSA scale</Form.Label>
                                <Form.Control name="msa" type='text' onChange={this.props.handler}/>
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <Form.Label> Parkinson Scale </Form.Label>
                                <Form.Control name="parkscale" type='text' onChange={this.props.handler}/>
                            </Form.Group>


                            <Form.Group as={Col}>
                                <Form.Label>PSP-RS scale</Form.Label>
                                <Form.Control name="psp_rs" type='text' onChange={this.props.handler}/>
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <Form.Label>Hoehn & Yahr</Form.Label>
                                <Form.Control name="hoen_yahr" type='text' onChange={this.props.handler}/>
                            </Form.Group>
                            <Form.Group as={Col}>
                                <Form.Label>MoCA</Form.Label>
                                <Form.Control name="moca" type='text' onChange={this.props.handler}/>
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <Form.Label>Frontal Assessment Battery</Form.Label>
                                <Form.Control name="fab" type='text' onChange={this.props.handler}/>
                            </Form.Group>
                            <Form.Group as={Col}>
                                <Form.Label>Claptest</Form.Label>
                                <Form.Control name="claptest" type='text' onChange={this.props.handler}/>
                            </Form.Group>
                        </Form.Row>
                        <Form.Group>
                            <Form.Label>Starkstein Apathy Scale </Form.Label>
                            <Form.Control name="sas" type='text' onChange={this.props.handler}/>
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>Dementia Apraxia Test </Form.Label>
                            <Form.Control name="date" type='text' onChange={this.props.handler}/>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Geratic Depression Scale </Form.Label>
                            <Form.Control name="gds" type='text' onChange={this.props.handler}/>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Schwab and England </Form.Label>
                            <Form.Control name="seadl" type='text' onChange={this.props.handler}/>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>SCOPA-AUT </Form.Label>
                            <Form.Control name="scopa_aut" type='text' onChange={this.props.handler}/>
                        </Form.Group>


                    </Form>
                </div>
            )
        }
        else if(this.props.action =='edit'){
            const clinicaldata = this.props.items
            const noEdit = this.props.preventEdit;

            return (

                <div>
                    <h4>Clinical Data</h4><br/>
                    <Form>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <Form.Label>PSP scale</Form.Label>
                                <Form.Control name="psp" type='text' onChange={this.props.handler} value={clinicaldata.psp ||''} disabled={noEdit} />
                            </Form.Group>
                            <Form.Group as={Col}>
                                <Form.Label>MSA scale</Form.Label>
                                <Form.Control name="msa" type='text' onChange={this.props.handler}  value={clinicaldata.msa || ''} disabled={noEdit}/>
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <Form.Label> Parkinson Scale </Form.Label>
                                <Form.Control name="parkscale" type='text' onChange={this.props.handler}  value={clinicaldata.parkscale || ''} disabled={noEdit}/>
                            </Form.Group>


                            <Form.Group as={Col}>
                                <Form.Label>PSP-RS scale</Form.Label>
                                <Form.Control name="psp_rs" type='text' onChange={this.props.handler}  value={clinicaldata.psp_rs || ''} disabled={noEdit}/>
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <Form.Label>Hoehn & Yahr</Form.Label>
                                <Form.Control name="hoen_yahr" type='text' onChange={this.props.handler}  value={clinicaldata.hoen_yahr ||''} disabled={noEdit}/>
                            </Form.Group>
                            <Form.Group as={Col}>
                                <Form.Label>MoCA</Form.Label>
                                <Form.Control name="moca" type='text' onChange={this.props.handler}  value={clinicaldata.moca|| ''} disabled={noEdit}/>
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <Form.Label>Frontal Assessment Battery</Form.Label>
                                <Form.Control name="fab" type='text' onChange={this.props.handler} value={clinicaldata.fab ||''} disabled={noEdit}/>
                            </Form.Group>
                            <Form.Group as={Col}>
                                <Form.Label>Claptest</Form.Label>
                                <Form.Control name="claptest" type='text' onChange={this.props.handler}  value={clinicaldata.claptest || ''} disabled={noEdit}/>
                            </Form.Group>
                        </Form.Row>
                        <Form.Group>
                            <Form.Label>Starkstein Apathy Scale </Form.Label>
                            <Form.Control name="sas" type='text' onChange={this.props.handler}  value={clinicaldata.sas || ''} disabled={noEdit}/>
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>Dementia Apraxia Test </Form.Label>
                            <Form.Control name="date" type='text' onChange={this.props.handler}  value={clinicaldata.date || ''} disabled={noEdit}/>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Geratic Depression Scale </Form.Label>
                            <Form.Control name="gds" type='text' onChange={this.props.handler}  value={clinicaldata.gds || ''} disabled={noEdit}/>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Schwab and England </Form.Label>
                            <Form.Control name="seadl" type='text' onChange={this.props.handler}  value={clinicaldata.seadl || ''} disabled={noEdit}/>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>SCOPA-AUT </Form.Label>
                            <Form.Control name="scopa_aut" type='text' onChange={this.props.handler}  value={clinicaldata.scopa_aut || ''} disabled={noEdit}/>
                        </Form.Group>


                    </Form>
                </div>
            )
        }
    }
}

export default Clinical_data;